import { useItem, useReport } from './hooks/use-context';
import moment from 'moment';

export function InitialInfos() {
  const { sections } = useItem();
  const { header } = useReport();

  const questions = sections.flatMap((section) => section.questions);

  const getAnswer = (id: string, useContent = false) => {
    const q = questions.find((q) => q.question_id === id);
    if (!q || !q.answers || q.answers.length === 0) return '';
    return useContent ? q.answers[0].content : q.answers[0].option || q.answers[0].content;
  };

  const involvedType = getAnswer('453088d7-9c23-42e3-96e4-b57d35e8eec4');
  const involvedNames = getAnswer('8eeffe91-e183-479a-8c37-dc28d61d8c3c', true);
  const fullName = involvedType ? `${involvedType} - ${involvedNames}` : involvedNames;
  const registry = getAnswer('337ad5d9-808b-4423-8e0b-3bede036d4b5', true);
  const role = getAnswer('3d6cfe12-c6ce-4db1-8f34-b45fc5d9f65a', true);
  const timeInFunc = getAnswer('77f218ce-3115-4af7-a7af-79b1363a571c', true);
  const location = getAnswer('7427e6ac-2a41-49ec-979a-1ecb4ba0aaac', true);
  const classification = getAnswer('8e851118-97da-4b9a-b1e1-699c63218944');
  const simplifiedInv = getAnswer('f601cd65-28a9-4d94-b414-f5c1462afd82');
  const tst = getAnswer('8d74d3c3-f159-4a95-b649-f8e49a4e3999', true) || header.author_full_name;
  
  const dateTimeAnswer = getAnswer('ab433035-bab5-45fb-9415-4e8d770a0c69', true);
  const refDateTime = dateTimeAnswer || header.event_date_time;

  const dateStr = refDateTime ? moment(refDateTime, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
  const timeStr = refDateTime ? moment(refDateTime, 'DD/MM/YYYY HH:mm:ss').format('HH:mm') : '';

  const renderCheckbox = (label: string, checked: boolean) => (
    <span style={{ marginRight: '15px', fontWeight: 'bold', fontSize: '13px' }}>
      ({checked ? 'X' : '  '}) {label}
    </span>
  );

  const isChecked = (label: string) => classification === label || simplifiedInv === label;

  return (
    <div style={{ color: '#000', fontSize: '13px', lineHeight: '1.5', fontFamily: 'sans-serif', margin: '15px 0' }}>
      <div style={{ display: 'flex', marginBottom: '8px' }}>
        <div style={{ flex: 1 }}><strong>Nome(s) do(s) envolvido(s):</strong> {fullName}</div>
      </div>

      <div style={{ display: 'flex', marginBottom: '16px' }}>
        <div style={{ flex: 1 }}><strong>Cadastro:</strong> {registry}</div>
      </div>
      
      <div style={{ display: 'flex', marginBottom: '16px' }}>
        <div style={{ flex: 1 }}><strong>Cargo/Área de Atuação:</strong> {role}</div>
        <div style={{ flex: 1 }}><strong>Tempo na função:</strong> {timeInFunc}</div>
      </div>

      <div style={{ display: 'flex', marginBottom: '16px' }}>
        <div style={{ flex: 1 }}><strong>Data:</strong> {dateStr}</div>
        <div style={{ flex: 1 }}><strong>Horário:</strong> {timeStr}</div>
        <div style={{ flex: 1 }}><strong>Local:</strong> {location}</div>
      </div>

      <div style={{ marginBottom: '8px' }}>
        <strong>TST responsável pela análise:</strong> {tst}
      </div>
      <div style={{ marginBottom: '24px' }}>
        <strong>Classificação:</strong> {classification || simplifiedInv}
      </div>

      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
        <div style={{ backgroundColor: '#F4B084', padding: '4px', fontWeight: 'bold', display: 'inline-block', width: '100%', marginBottom: '8px', fontSize: '14px' }}>
          INVESTIGAÇÃO PROFUNDA (UTILIZAR METODOLOGIA ÁRVORE DE CAUSAS)
        </div>
        <div>
          {renderCheckbox('CAF', isChecked('CAF'))}
          {renderCheckbox('SAF', isChecked('SAF'))}
          {renderCheckbox('EAR', isChecked('EAR'))}
          {renderCheckbox('EA', isChecked('EA'))}
          {renderCheckbox('AV- Grupo 2', isChecked('AV- Grupo 2'))}
        </div>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <div style={{ backgroundColor: '#B4C6E7', padding: '4px', fontWeight: 'bold', display: 'inline-block', width: '100%', marginBottom: '8px', fontSize: '14px' }}>
          INVESTIGAÇÃO SIMPLIFICADA (UTILIZAR METODOLOGIA 5 PORQUÊS)
        </div>
        <div>
          {renderCheckbox('PS', isChecked('PS'))}
          {renderCheckbox('QUASE ACIDENTE', isChecked('QUASE ACIDENTE'))}
          {renderCheckbox('AV- Leve', isChecked('AV- Leve'))}
        </div>
      </div>
    </div>
  );
}
